import React, { FC, useRef } from 'react';
import Dropdown from './components/dropdown';
import TextSearch from './components/textSearch';
import { TDealerLocatorSearchProps } from '../../../../types/dealerLocator.types';
import { fetchDealersByGeoCode } from '../../dealerLocator.utils';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import useSitecoreContext from '../../../../../../hooks/useSitecoreContext';

const DealerLocatorSearch: FC<TDealerLocatorSearchProps> = ({
  onDealerResults,
  country,
  countries,
  setCountry,
  autocompleteService,
  placesService,
  searchInputValue,
  setSearchInputValue,
  onTextInputClick,
  updatedSelectedPlaceId,
  prevSelectedResult,
}) => {
  const { t } = useTranslation();
  const {sitecoreContext} = useSitecoreContext();
  const itemID = sitecoreContext?.route?.itemId;
  const siteLanguage = sitecoreContext?.language || '';
  const controllerRef = useRef<AbortController | null>();
  const countryIsoCodeWithFallback = country?.IsoCode;

  const onGooglePlaceSelect = (place: any) => {
    const lat = place.geometry?.location?.lat() || '';
    const lng = place.geometry?.location?.lng() || '';

    if (lat && lng) {
      const apiCallParams = {
        lat: lat,
        lng: lng,
        pageId: itemID,
        language: siteLanguage,
        countryIsoCode: countryIsoCodeWithFallback,
      };

      fetchDealersByGeoCode(apiCallParams, controllerRef)
        .then((data) => {
          const dealershipResults = data?.dealershipResults;
          onDealerResults({
            results: dealershipResults || [],
          });
        })
        .catch((error) => {
          onDealerResults({
            results: [],
          });
          console.error(error, 'Error while fetching Dealers');
        });
    }
  };

  return (
    <div className="preferred-dealer-search">
      <div className="preferred-dealer-search__col preferred-dealer-search__col--dropdown">
        <Dropdown items={countries} label={t('cnhi-formsDealerLocatorCountry')} onSelect={setCountry} country={country} />
      </div>
      <div className="preferred-dealer-search__col preferred-dealer-search__col--text-search">
        <TextSearch
          countryIsoCode={country?.IsoCode}
          label={t('cnhi-formsDealerLocatorSearchByLocationOrDealer')}
          onGooglePlaceSelect={onGooglePlaceSelect}
          autocompleteService={autocompleteService}
          placesService={placesService}
          siteLanguage={siteLanguage}
          searchInputValue={searchInputValue}
          setSearchInputValue={setSearchInputValue}
          onClick={onTextInputClick}
          updatedSelectedPlaceId={updatedSelectedPlaceId}
          prevSelectedResult={prevSelectedResult}
        />
      </div>
    </div>
  );
};

export default DealerLocatorSearch;
